import {Battery, ClientsActions, ClientsState, GetState, IssuesActions, IssuesState, OrganizationClient} from "types";
import {
  batteryManagmentServiceClient,
  organizationManagementServiceClient
} from "utils/grpc-clients";
import {
  AddBatteryRequest, AddBatteryResponse,
  BatteryItem,
  BatteryUpdateItem,
  GetBatteriesRequest,
  GetBatteriesResponse
} from "../../protobuf/battery_service_pb";
import {Dispatch} from "react";
import {apiResponse} from "./common-actions";
import {BatteryManagementServiceClient} from "../../protobuf/Battery_serviceServiceClientPb";
import {initializeBatteries, setBatteries} from "./battery-actions";
import {
    AddOrganizationRequest,
    AddOrganizationResponse,
    ClientOwnerItem,
    DeleteOrganizationRequest,
    DeleteOrganizationResponse,
    ListOwnerOrgAdminRequest,
    ListOwnerOrgAdminResponse,
    OwnerOrgItem,
    UpdateOrganizationRequest,
    UpdateOrganizationResponse,
    UpdateOwnerOrgItem
} from "../../protobuf/client_service_pb";
import {OrganizationAdminServiceClient} from "../../protobuf/Client_serviceServiceClientPb";
import {SUCCESS_MESSAGES} from "../../utils/constants";
import {Address} from "../../protobuf/user_service_pb";
import {setClients} from "./vehicles-actions";
import {boolean} from "yup";


export function initializeClients(
    businessType?: number,
    listType?: string
){
  const request = new ListOwnerOrgAdminRequest()
    request.setBusinessType(businessType || 1)
    if (listType == "archived") {
        request.setIsArchived(true)
    }
  return async (dispatch: Dispatch<any>) => {

    function dispatcher(resp: ListOwnerOrgAdminResponse) {
      let organizations: OrganizationClient[] = resp?.getOwnerOrgsList()?.map(organizations => ({
        ...(organizations.getOwnerOrg()?.toObject() as OwnerOrgItem.AsObject),
        ownerOrgName: "Test Owner",
        clientUserItem: organizations.getUser()?.toObject()
      }));
      console.log("organizations from DB: ", organizations)
        console.log("business Type : ", businessType)

      // Sort clients alphabetically by name before dispatching
      organizations = organizations.sort((a, b) =>
        (a.name || "").localeCompare(b.name || "")
      );
      dispatch(setClientList(organizations))
      dispatch(setClients(organizations));
    }
    dispatch(
        apiResponse<
            OrganizationAdminServiceClient,
            ListOwnerOrgAdminRequest,
            ListOwnerOrgAdminResponse
            >({
          client: organizationManagementServiceClient,
          action: "listOwnerOrgs",
          request,
          dispatcher,
        })
    );
  };
}


export function addOrganization({
    name,
    street_address,
    city,
    state,
    country, org_type,business_type,email,phone_number,national_id} : {
  name:string,
  street_address:string,
  city:string,
  state:string,
  country:string,
    org_type:string,
    business_type:number,
    email:string,
    phone_number:string,
    national_id:string,

}) {
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const {setSelectedTab} = getState().clients
      var selectedType = 1
      if (setSelectedTab == "B2C clients") {
          selectedType = 2;
      }

    const request = new AddOrganizationRequest();
    const orgOwnerItem = new UpdateOwnerOrgItem();
      const clientItem = new ClientOwnerItem()
    const address = new Address();
    console.log("org_type : ", org_type)
    console.log("business type :", business_type)
    request.setBusinessType(business_type)
    address.setStreetAddress1(street_address)
    address.setStreetAddress2(street_address)
    address.setCity(city)
    address.setState(state)
    address.setCountry(country)
    orgOwnerItem.setName(name);
    orgOwnerItem.setAddress(address)
      orgOwnerItem.setOrgType(org_type)
      if(business_type == 2) {
          clientItem.setName(name)
          clientItem.setAddress(address)
          clientItem.setNationalId(national_id)
          clientItem.setEmail(email)
          clientItem.setPhoneNumber(phone_number)
          request.setClientItem(clientItem)
      } else {
          request.setOwnerItem(orgOwnerItem)
      }
    function dispatcher() {
          console.log("setSelectedTab in Dispatcher : ", setSelectedTab)
          console.log("Selected type in Dispatcher : ", selectedType)
      dispatch(initializeClients(selectedType));
    }

    dispatch(
        apiResponse<
            OrganizationAdminServiceClient,
            AddOrganizationRequest,
            AddOrganizationResponse
            >({
          request,
          client: organizationManagementServiceClient,
          action: "addOrganization",
          successMessage: SUCCESS_MESSAGES.addOrganization,
          dispatcher,
        })
    );
  };
}

export function updateOrganization({
                                 id,
                                  name,
                                  street_address,
                                  city,
                                  state,
                                  country,org_type, business_type, email, phone_number, national_id} : {
  id:string
  name:string,
  street_address:string,
  city:string,
  state:string,
  country:string
  org_type:string,
  business_type?:number,
  email?:string,
  phone_number?:string,
  national_id?:string,


}) {
  return (dispatch: Dispatch<any>, getState: GetState) => {

    const request = new UpdateOrganizationRequest();
    const orgOwnerItem = new UpdateOwnerOrgItem();
    const address = new Address();
    const clientItem = new ClientOwnerItem()
    if (business_type == 2) {
        clientItem.setEmail(email || "")
        clientItem.setNationalId(national_id || "")
        clientItem.setPhoneNumber(phone_number || "")
        request.setClientItem(clientItem)
    }
    address.setStreetAddress1(street_address)
    address.setStreetAddress2(street_address)
    address.setCity(city)
    address.setState(state)
    address.setCountry(country)
    orgOwnerItem.setName(name);
    orgOwnerItem.setAddress(address)
      orgOwnerItem.setOrgType(org_type)
    request.setOwnerItem(orgOwnerItem)
    request.setId(id)
    function dispatcher() {
      dispatch(initializeClients(business_type));
    }

    dispatch(
        apiResponse<
            OrganizationAdminServiceClient,
            UpdateOrganizationRequest,
            UpdateOrganizationResponse
            >({
          request,
          client: organizationManagementServiceClient,
          action: "updateOrganization",
          successMessage: SUCCESS_MESSAGES.updateOrganization,
          dispatcher,
        })
    );
  };
}


export function deleteOrganization({id,} : {
    id:string,

}) {
    return (dispatch: Dispatch<any>, getState: GetState) => {
        const {setSelectedTab} = getState().clients
        var selectedType = 1
        if (setSelectedTab == "B2C clients") {
            selectedType = 2;
        }

        const request = new DeleteOrganizationRequest();
        request.setId(id)
        function dispatcher() {
            console.log("setSelectedTab in Dispatcher : ", setSelectedTab)
            console.log("Selected type in Dispatcher : ", selectedType)
            dispatch(initializeClients(selectedType));
        }

        dispatch(
            apiResponse<
                OrganizationAdminServiceClient,
                DeleteOrganizationRequest,
                DeleteOrganizationResponse
            >({
                request,
                client: organizationManagementServiceClient,
                action: "deleteOrganization",
                successMessage: SUCCESS_MESSAGES.deleteOrganization,
                dispatcher,
            })
        );
    };
}

export function setBulkActionsClients(
  payload: ClientsState["showbulkActionsClients"]
): ClientsActions {
  return {
    type: "SET_CLIENT_BULK_ACTIONS",
    payload,
  };
}

export function setClientList(
    payload: ClientsState["organizations"]
): ClientsActions{
  return {
    type: "SET_CLIENTS",
    payload
  }
}

export function setSelectedClientTab(
    payload:ClientsState["setSelectedTab"]
): ClientsActions {
    return {
        type: "SET_SELECTED_TAB",
        payload
    }
}

export function setSelectedClient(
    payload: ClientsState["selectedOrganization"]
): ClientsActions {
    return {
        type: "SET_SELECTED_ORGANIZATION",
        payload
    }
}

export function setClientSearch(
  payload: ClientsState["search"]
): ClientsActions {
  return {
    type: "SET_CLIENT_SEARCH",
    payload,
  };
}


export function setClientListType(
    payload: ClientsState["filters"]["listType"]
): ClientsActions {
    return {
        type: "SET_CLIENT_LIST_TYPE",
        payload,
    };
}
